import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            "url(https://readdy.ai/api/search-image?query=dark%20abstract%20entertainment%20background%20with%20warm%20red%20and%20amber%20gradient%20accents%2C%20cinematic%20glow%20effects%2C%20dramatic%20atmospheric%20lighting%2C%20modern%20minimal%20design%2C%20smooth%20gradient%20texture%2C%20no%20text%2C%20no%20people%2C%20elegant%20dark%20wallpaper&width=1920&height=1080&seq=hero-bg-01&orientation=landscape)",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 mb-6">
            <i className="ri-fire-line text-primary-400"></i>
            <span className="text-sm text-primary-300">今日热搜 · 实时更新</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white mb-6 leading-tight">
            每日新鲜<span className="text-primary-400">吃瓜</span>
            <br />
            精彩内容<span className="text-accent-400">不间断</span>
          </h1>

          <p className="text-base md:text-lg text-background-200 max-w-2xl mx-auto mb-8 leading-relaxed">
            汇聚全网最新明星八卦、网红爆料、娱乐内幕，高清视频在线观看，每天更新最新吃瓜内容，让你不错过任何一个精彩瞬间
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/mingxing-bagua"
              className="px-8 py-3 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line mr-2"></i>
              立即观看
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 bg-white/10 text-white rounded-full text-sm font-medium hover:bg-white/20 transition-all border border-white/20 whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>

          <div className="flex items-center justify-center gap-8 mt-10">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading text-white">10万+</p>
              <p className="text-xs text-background-300 mt-1">每日活跃用户</p>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading text-white">5000+</p>
              <p className="text-xs text-background-300 mt-1">视频内容</p>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading text-white">8大</p>
              <p className="text-xs text-background-300 mt-1">热门分类</p>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white/60 text-xl"></i>
      </div>
    </section>
  );
}